export default __webpack_public_path__ + "static/media/a011-fsi-01.ad069d0f.svg";